import * as React from "react";
import { useParams } from "react-router";
import PageContents from "../components/layouts/PageContents";
import ManageProjectVideosContainer from "../containers/ManageProjectVideosContainer";
import { FOUR_D_VISUALISATION } from "../assets/Constants";

const ProjectVideosPage: React.FC = () => {
    const [title, setTitle] = React.useState(`${FOUR_D_VISUALISATION}`);
    const [subtitle, setSubtitle] = React.useState(
        `Please wait while we retrieve the ${FOUR_D_VISUALISATION} list...`
    );
    const [isForbidden, setIsForbidden] = React.useState(false);
    const { projectId } = useParams();

    return (
        <PageContents
            title={title}
            subtitle={subtitle}
            isForbidden={isForbidden}
            variant="small"
        >
            <ManageProjectVideosContainer
                projectId={projectId!}
                setTitle={setTitle}
                setSubtitle={setSubtitle}
                setIsForbidden={setIsForbidden}
            />
        </PageContents>
    );
};

export default ProjectVideosPage;
